import { User } from 'fitify-types/src/types/user'
import { type FaqProps } from 'fitify-ui-onboarding/src/components/Paywall/Faq/Faq'
import { type TFunction } from 'next-i18next/pages'

import { Funnel } from 'types/state'
import { isGainMuscleOffered } from 'utils/funnel'

export type PaywallFaqItem = Pick<FaqProps, 'answer' | 'question'>

const getGoalDefaultFaqItem = (t: TFunction): PaywallFaqItem => {
  return {
    question: t('paywall_faq_goal_default_question'),
    answer: t('paywall_faq_goal_default_answer'),
  }
}

export const getGoalFaqItem = ({
  funnel,
  gender,
  goal,
  t,
}: {
  funnel?: Funnel
  gender?: User.Profile.Gender
  goal?: User.Profile.Goals
  t: TFunction
}): PaywallFaqItem => {
  const isGym = funnel === Funnel.GYMF01

  switch (goal) {
    case User.Profile.Goals.LoseWeight:
      return {
        question: t('paywall_faq_goal_lose_weight_question'),
        answer: isGym
          ? t('paywall_faq_goal_lose_weight_answer_gym')
          : t('paywall_faq_goal_lose_weight_answer'),
      }
    case User.Profile.Goals.GetToned:
      if (isGainMuscleOffered({ funnel, gender })) {
        return {
          question: t('paywall_faq_goal_gain_muscle_question'),
          answer: isGym
            ? t('paywall_faq_goal_gain_muscle_answer_gym')
            : t('paywall_faq_goal_gain_muscle_answer'),
        }
      }
      return gender === User.Profile.Gender.Female
        ? {
            question: t('paywall_faq_goal_get_toned_question'),
            answer: t('paywall_faq_goal_get_toned_answer'),
          }
        : getGoalDefaultFaqItem(t)
    case User.Profile.Goals.LoseFatGainMuscle:
      return {
        question: t('paywall_faq_goal_lose_fat_build_muscle_question'),
        answer: t('paywall_faq_goal_lose_fat_build_muscle_answer'),
      }
    case User.Profile.Goals.GetFit:
      return {
        question: t('paywall_faq_goal_improve_fitness_question'),
        answer: t('paywall_faq_goal_improve_fitness_answer'),
      }
    case User.Profile.Goals.GetActive:
      return {
        question: t('paywall_faq_goal_improve_mobility_question'),
        answer: t('paywall_faq_goal_improve_mobility_answer'),
      }
    default:
      return getGoalDefaultFaqItem(t)
  }
}

export const getFunnelFaqItem = ({
  funnel,
  t,
}: {
  funnel?: Funnel
  t: TFunction
}): PaywallFaqItem => {
  switch (funnel) {
    case Funnel.F01:
    case Funnel.M01:
      return {
        question: t('paywall_faq_benefits_question_calisthenics'),
        answer: t('paywall_faq_benefits_answer_calisthenics'),
      }
    case Funnel.MILICAF01:
    case Funnel.MILICAM01:
      return {
        question: t('paywall_faq_benefits_question_milica'),
        answer: t('paywall_faq_benefits_answer_milica'),
      }
    case Funnel.CHF01:
    case Funnel.CHM01:
      return {
        question: t('paywall_faq_benefits_question_ch'),
        answer: t('paywall_faq_benefits_answer_ch'),
      }
    case Funnel.TCHF01:
    case Funnel.TCHM01:
      return {
        question: t('paywall_faq_benefits_question_ch_taichi'),
        answer: t('paywall_faq_benefits_answer_ch_taichi'),
      }
    case Funnel.WALLPIF01:
      return {
        question: t('paywall_faq_benefits_question_wallpi'),
        answer: t('paywall_faq_benefits_answer_wallpi'),
      }
    case Funnel.GYMF01:
      return {
        question: t('paywall_faq_benefits_question_gym'),
        answer: t('paywall_faq_benefits_answer_gym'),
      }
    case Funnel.HOPIF01:
      return {
        question: t('paywall_faq_benefits_question_home_pilates'),
        answer: t('paywall_faq_benefits_answer_home_pilates'),
      }
    default:
      return {
        question: t('paywall_faq_benefits_question_default'),
        answer: t('paywall_faq_benefits_answer_default'),
      }
  }
}
